import * as Glob from './Globale';

export type Metodi = "GET" | "POST" | "PUT" | "DELETE";

export type TParamURLLista = { [Param: string]: any };

export class CChiamaWebParametri {
    Nome?: string = "";
    URL: string = "";
    ParamURLLista?: TParamURLLista;
    ParamURLClasse?: any
    ParamCorpo?: any
    Metodo?: Metodi = "GET";
    OnRis?: (sender: ChiamaWeb, dati: any) => void;
    OnRisTesto?: (sender: ChiamaWeb, testo: string) => void;
    OnErrore?: (sender: ChiamaWeb, errore: Error) => void;
    OnInvio?: (sender: ChiamaWeb) => any;
}

export default class ChiamaWeb {
    private  Attesa: string;

    constructor() {
        this.Attesa = "";
    }

    private CalcolaURL(param: CChiamaWebParametri): string {
        let URL: string = param.URL;
        if (param.ParamURLLista != undefined) {
            URL += (URL.indexOf("?") > -1 ? "&" : "?");
            for (let P in param.ParamURLLista) {
                URL += encodeURIComponent(P) + "=" + encodeURIComponent(param.ParamURLLista[P]) + "&";
            }
        }
        if (param.ParamURLClasse != undefined) {
            URL += (URL.indexOf("?") > -1 ? "&" : "?");
            for (let P in param.ParamURLClasse) {
                URL += encodeURIComponent(P) + "=" + encodeURIComponent(param.ParamURLClasse[P]) + "&";
            }
        }
        if (URL.toLowerCase().indexOf("sessione=") == -1) {
            URL += (URL.indexOf("?") > -1 ? "&" : "?") + "sessione=" + Glob.GetSessione().Sessione;
        }
        return URL;
    }

    public static ChiamaWeb(param: CChiamaWebParametri) {
        new ChiamaWeb().Chiama(param);
    }

    public Chiama(param: CChiamaWebParametri) {
        let URL = this.CalcolaURL(param);
        if (this.Attesa) {
            Glob.LogInfo(Glob.LogCat.API, "Già in attesa per caricamento ChiamaWeb (" + param.Nome + "): " + param.URL, [URL, this.Attesa]);
        }
        else {
            this.Attesa = URL;

            var RI: RequestInit = {};
            RI.headers = {
                'Accept': 'application/json', 'Content-Type': 'application/json', 'apiKey': '7db02b5e-3686-4bd1-b7d3-4ffb6dff7b5c'
            };
            if ((param.ParamCorpo != undefined || param.OnInvio != undefined) && param.Metodo == "GET") {
                RI.method = "POST";
            }
            else {
                RI.method = param.Metodo;
            }
            let TestoLog = "";
            if (param.ParamCorpo != undefined) {
                RI.body = JSON.stringify(param.ParamCorpo);
                TestoLog = "ParamCorpo";
            } else {
                if (param.OnInvio != undefined) {
                    let OnInvio = param.OnInvio(this);
                    if (OnInvio == false) {
                        this.Attesa = "";
                        return;
                    }
                    RI.body = JSON.stringify(OnInvio);
                    TestoLog = "OnInvio";
                }
                else {
                    TestoLog = "Vuoto";
                }
            }
            Glob.LogInfo(Glob.LogCat.API, "Attesa caricamento ChiamaWeb - " + TestoLog + " (" + param.Nome + "): " + RI.method + " " + param.URL, RI.body);

            fetch(URL, RI)
                .then(response => {
                    if (response.ok) {
                        response.text().then(text => {
                            this.Attesa = "";

                            if (param.OnRis != undefined) {
                                let data = JSON.parse(text, Glob.DateReviver);
                                Glob.Log(Glob.LogCat.API, false, "Risultato caricamento JSON ChiamaWeb (" + param.Nome + "): " + param.URL, data);
                                param.OnRis(this, data);
                            }
                            if (param.OnRisTesto != undefined) {
                                Glob.Log(Glob.LogCat.API, false, "Risultato caricamento Testo ChiamaWeb (" + param.Nome + "): " + param.URL, text);
                                param.OnRisTesto(this, text);
                            }
                        }).catch(e => {
                            this.Attesa = "";
                            Glob.Log(Glob.LogCat.API, true, "Errore caricamento ChiamaWeb (" + param.Nome + "): " + param.URL + " (JSON)", e);
                            if (param.OnErrore != undefined) {
                                param.OnErrore(this, e);
                            }
                        });
                    }
                    else {
                        this.Attesa = "";
                        Glob.Log(Glob.LogCat.API, true, "Errore caricamento ChiamaWeb (" + param.Nome + "): " + param.URL + " (HTTP)", response);
                        if (param.OnErrore != undefined) {
                            param.OnErrore(this, new Error(response.statusText));
                        }
                    }
                })
                .catch(e => {
                    this.Attesa = "";
                    Glob.Log(Glob.LogCat.API, true, "Errore caricamento ChiamaWeb (" + param.Nome + "): " + param.URL + " (Rete)", e);
                    if (param.OnErrore != undefined) {
                        param.OnErrore(this, e);
                    }
                });
        }
    }
}



// WEBPACK FOOTER //
// ./src/ChiamaWeb.tsx